import React from 'react';
import { Typography } from '@mui/material';

function Profile() {
  return (
    <div>
      <Typography variant="h4" component="h1" gutterBottom>
        Inicio
      </Typography>
      <Typography variant="body1">
        Bienvenido a la página de Perfil.
      </Typography>
    </div>
  );
}

export default Profile;
